import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {api_url} from "../url.js"

const AuthContext = createContext()

export default AuthContext;

export const AuthProvider = ({children}) => {
    
    const [ user, setUser] = useState(null)
    const [loggingIn, setLoggingIn] = useState(false)
    const [authToken, setAuthToken] = useState(null)

    const navigate = useNavigate()

    const loginUser = async(e) => {
        e.preventDefault()
        const username = e.target.username.value;
        const password = e.target.password.value;
        const config = {
            headers:{
                "Content-Type": "application/json",
            }
        }
        const body = JSON.stringify({
            "username": username,
            "password": password
        })
        setLoggingIn(true)
        try {
            await axios.post(`${api_url}authentication/login/`,body,config).then((response) => {
                localStorage.setItem("access",response.data['access'])
                localStorage.setItem("refresh",response.data['refresh'])
                getUser();
                navigate("/dashboard")
                setLoggingIn(false)
            })
        } catch (error) {
            toast.error("Invalid username or password")
            setUser(null)
            setLoggingIn(false)
        }
    }

    const getUser = async() => {
        
        if(localStorage.getItem("access")){
            try {
                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization":`JWT ${localStorage.getItem("access")}`
                    }
                }
                await axios.get(`${api_url}accounts/me/`,config).then((response)=>{
                    if(response.status === 200){
                        setUser(response.data)
                        navigate('/dashboard')
                    }
                })
            } catch (error) {
                // toast.error("You are not authorized to access this page")
                setUser(null)
            }
        }
    }

    const logoutUser = () => {
        setAuthToken(null)
        setUser(null)
        localStorage.removeItem("access")
        navigate('/login')
    }

    let contextData = {
        user:user,
        loginUser:loginUser,
        logoutUser:logoutUser,
        loggingIn:loggingIn
    }

    useEffect(()=>{
        getUser()
    },[])

    return (
        <AuthContext.Provider value={contextData}>
            {children}
        </AuthContext.Provider>
    )
}